import { useQuery } from '@tanstack/react-query';
import {
  pointsTransactionsService,
  FetchPointsTransactionsRequest,
  FetchPointsTransactionsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchPointsTransactions = (
  {
    ids,
    individualIds,
    potIds,
    walletIds,
    companyIds,
    moneyTransactionIds,
    directions,
    categories,
    reasons,
    startDate,
    endDate,
    sortBy,
    sort,
    size,
    page,
  }: FetchPointsTransactionsRequest,
  enabled = true
) => {
  const toast = useToast();

  return useQuery<FetchPointsTransactionsResponse, Error>({
    queryKey: [
      'fetchPointsTransactions',
      ids,
      individualIds,
      potIds,
      walletIds,
      companyIds,
      moneyTransactionIds,
      directions,
      categories,
      reasons,
      startDate,
      endDate,
      sortBy,
      sort,
      size,
      page,
    ],
    queryFn: () =>
      pointsTransactionsService.fetchPointsTransactions({
        ids,
        individualIds,
        potIds,
        walletIds,
        companyIds,
        moneyTransactionIds,
        directions,
        categories,
        reasons,
        startDate,
        endDate,
        sortBy,
        sort,
        size,
        page,
      }),
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Sorry, we failed to fetch the points transactions. Please try again.',
      });
    },
  });
};

export default useFetchPointsTransactions;
